import { SkeletonBase } from "./Skeleton";

export default SkeletonBase;
